export default "__VITE_ASSET__77115890__"